module.exports = "g.tick.ng-start-inserted { min-width: 50px; }\r\n\r\n.progress {\r\n\twidth: 250px !important;\r\n}"